import React from 'react'
import classNames from 'classnames'
import { Container } from 'components/shared'
import { APP_NAME } from 'constants/app.constant'
import { PAGE_CONTAINER_GUTTER_X } from 'constants/theme.constant'
import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom";

const FooterContent = () => {
    const { t } = useTranslation()

    return (
        <div className="flex items-center justify-between flex-auto w-full">
            <span>
                {t('copyright')} &copy; {`${new Date().getFullYear()}`}{' '}
                <span className="font-semibold">{t(`${APP_NAME}`)}</span> {t('allRightsReserved')}
            </span>
            <div className="">
                <Link
                    className="text-gray"
                    to="/terms-and-conditions"
                >{t('termAndConditions')}</Link>
            </div>
        </div>
    )
}

export default function Footer({ pageContainerType }) {
    return (
        <footer
            className={classNames(
                `footer flex flex-auto items-center h-16 ${PAGE_CONTAINER_GUTTER_X}`
            )}
        >
            {pageContainerType === 'contained' ? (
                <Container>
                    <FooterContent />
                </Container>
            ) : (
                <FooterContent />
            )}
        </footer>
    )
}
